import { createContext, useCallback, useContext, useMemo } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useTheme } from './ThemeContext';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const toastStyle = useMemo(
    () =>
      isDark
        ? { background: '#18181b', color: '#fafafa', border: '1px solid #3f3f46' }
        : { background: '#ffffff', color: '#18181b', border: '1px solid #e4e4e7' },
    [isDark]
  );

  const showToast = useCallback((message, type = 'info') => {
    if (type === 'success') {
      toast.success(message);
    } else if (type === 'error') {
      toast.error(message);
    } else {
      toast(message, { style: toastStyle });
    }
  }, [toastStyle]);

  const value = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: toastStyle,
          success: { iconTheme: { primary: '#10b981', secondary: isDark ? '#18181b' : '#fff' } },
          error: { iconTheme: { primary: '#ef4444', secondary: isDark ? '#18181b' : '#fff' } },
        }}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
};
